import { Avatar, Button, Card, Col, Descriptions, Form, Spin, Row, Skeleton, Space, Select, Typography, Input, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import AddTuitionForm from './AddTuitionForm';
import ConfirmPopover from './ConfirmTuitionFee/Component/ConfirmPopover';
import { useParams } from 'react-router-dom'
import { useBillPaymentGradeClassStudent } from './BillPayment/controller/useBillPaymentGradeClassStudent'
import { useConfirmTuitionFeeStudentDetail } from './ConfirmTuitionFee/Controller/useConfirmTuitionFeeStudentDetailController'

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => !value ? { ...all } : { ...all, [key]: value }, {})
}
const AdminStudentTuition = ({
    defaultalue,
    ...props
}) => {
    let { bill_payment_grade_class_id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm()
    const [data, set_data] = useState({});
    const [open, setOpen] = useState([])
    const [check, set_check] = useState([])
    const [extra_columns, set_extra_columns] = useState([]);
    const [formulaOption, setFormulaOption] = useState([])
    const [count, setCount] = useState(0);
    const [formCount, setFormCount] = useState(0)
    const [canExport, setCanExport] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selectDate, setSelectDate] = useState([])
    const [popConfirmOpen, setPopConfirmOpen] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("")
    const getData = () => {
        axios
            .get(`/cramSchool/api/bill_payment_grade_class`, {
                params: {
                    bill_payment_grade_class_id: bill_payment_grade_class_id
                }
            })
            .then((response) => {

                let data = response.data?.data
                let first_data = data.find(ele => true)
                let payment_time = []
                let payment_limit_time = []
                let old_payment_time = []


                if (first_data?.payment_time_start && first_data?.payment_time_end) {
                    payment_time = [dayjs(first_data?.payment_time_start), dayjs(first_data?.payment_time_end)]
                    old_payment_time = [dayjs(first_data?.payment_time_start), dayjs(first_data?.payment_time_end)]
                }
                if (first_data?.payment_limit_time_start && first_data?.payment_limit_time_end) {
                    payment_limit_time = [dayjs(first_data?.payment_limit_time_start), dayjs(first_data?.payment_limit_time_end)]
                } else {
                    if (first_data?.payment_time_start && first_data?.payment_time_end) {
                        payment_limit_time = [dayjs(first_data?.payment_time_start).subtract(7, 'days'), dayjs(first_data?.payment_time_start).subtract(1, 'days')]
                    }
                }

                if (first_data?.grade_class_id) {
                    //獲得上課日與補習班放假日重疊日期
                    // getCrossHoliday({
                    //     grade_class_id: first_data?.grade_class_id
                    // })
                    // 
                    getSerialDateCrossHoliday({
                        grade_class_id: first_data?.grade_class_id,
                        start_time: first_data?.payment_time_start,
                        end_time: first_data?.payment_time_end
                    })

                }
                let studentDatas = (first_data?.student_data || []).map((studentData) => {
                    let bill_student_installment_data = (studentData?.bill_student_installment_data || []).map((installment_data) => {
                        let payment_limit_time = []
                        if (!!installment_data?.payment_limit_start_time && !!installment_data?.payment_limit_end_time) {
                            let start = dayjs(installment_data?.payment_limit_start_time, "YYYY-MM-DD")
                            let end = dayjs(installment_data?.payment_limit_end_time, "YYYY-MM-DD")
                            payment_limit_time = [start, end]
                        }

                        return {
                            payment_status: installment_data?.payment_status,
                            payment_time: installment_data?.payment_time,
                            bill_student_cost: installment_data?.bill_student_cost,
                            bill_student_installment_id: installment_data?.bill_student_installment_id,
                            bill_student_installment_serial: installment_data?.bill_student_installment_serial,
                            payment_limit_time
                        }
                    })

                    if (studentData?.installment_count > 1) {

                        return {
                            ...studentData,
                            installment: 1,
                            bill_student_installment_data
                        }
                    }
                    else {
                        return {
                            ...studentData,
                            installment: undefined,
                            bill_student_installment_data
                        }
                    }
                })
                let newFormData = {
                    ...first_data,
                    name: first_data?.lesson_name,
                    old_payment_time: old_payment_time,
                    payment_time: payment_time,
                    payment_limit_time,
                    lesson_Salary_TABLE_Formula_data: first_data.bill_payment_grade_class_Salary_TABLE_Formula_data || [],
                    student_data: studentDatas
                }
                set_data(newFormData)
                form.setFieldsValue({ ...newFormData })
                setCount(pre => pre + 1)
                setFormCount(pre => pre + 1)
            })
            .finally(() => {
            })
    }
    const getFormula = (param, sort, filter, checklist) => {
        axios
            .get(`/Salary/formula/dataLoad`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    custom_filter_key: checklist,
                    custom_filter_value: param?.keyword,
                    order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                let data = response.data.data.aRows
                setFormulaOption((pre) => {
                    return data.map((value) => {
                        let FormulaRule_data = value?.FormulaRule_data
                        let item = FormulaRule_data.find((ele) => true)
                        let fNumeric = item?.fNumeric

                        return {
                            label: `${value?.cName}(${fNumeric})`,
                            value: value?.iFormulaID,
                            fNumeric: fNumeric
                        }
                    })
                })
            })
            .finally(() => {
            })
    }
    const onFinish = (data) => {
        setLoading(true)
        axios
            .patch(`/cramSchool/api/bill_payment_grade_class`,
                data
            )
            .then((response) => {
                if (response.data.status === 'success') {
                    message.success("修改成功")
                } else {
                    message.error("修改失敗")
                }
                setCanExport(true)
            })
            .finally(() => {
                setLoading(false)
                getData()
            })
    }
    const onNotification = (data) => {

        postBillPaymentGradeClassStudentNotification([{
            bill_payment_id: form.getFieldValue('bill_payment_id'),
        }])
    }
    const handleOpenChange = (newOpen) => {
        if (!newOpen) {
            setPopConfirmOpen(newOpen);
            return;
        }
        let confirmOpen = false
        let confirmMessageTemp = '修改可能會影響學生權益，確定進行修改嗎？'
        let formData = form.getFieldsValue()
        let payment_limit_time = formData?.payment_limit_time
        let studentCount = 0
        let student_data = formData?.student_data || []
        student_data.forEach((ele) => {
            let bill_student_installment_data = ele?.bill_student_installment_data || []
            let studentPaymentStatus = bill_student_installment_data.some((element) => {
                return element?.payment_status === "已繳費"
            })
            if (studentPaymentStatus) {
                studentCount++
            }
        })
        let today = dayjs().format("YYYY-MM-DD")
        let payment_limit_time_start = dayjs(payment_limit_time[0]).format("YYYY-MM-DD")
        let result = dayjs(today).isBefore(payment_limit_time_start)
        if (result === false || studentCount > 0) {
            confirmOpen = true
            if (result === false && studentCount > 0) {
                confirmMessageTemp = `此繳費單已經進入繳費期限內，且有${studentCount}位學生付款，修改可能會影響學生權益，確定進行修改嗎？`
            }
            else if (result === false) {
                confirmMessageTemp = '此繳費單已經進入繳費期限內，修改可能會影響學生權益，確定進行修改嗎？'
            }
            else if (studentCount > 0) {
                confirmMessageTemp = `此繳費單已經有${studentCount}位學生付款，修改可能會影響學生權益，確定進行修改嗎？`
            }
            
        }
        setConfirmMessage(confirmMessageTemp)
        if (confirmOpen) {
            setPopConfirmOpen(newOpen);
        } else {
            form.submit()
        }
    }
    const {
        postBillPaymentGradeClassStudentNotification,
    } = useConfirmTuitionFeeStudentDetail(
        {
            onFinish: ({ axiosMode, status }) => {
                if (status === "success") {
                    message.info("已進行通知")
                }
                else {
                    message.error("請再試一次")
                }
            },
            onBefore: () => { }
        }
    )
    useEffect(() => {
        getData()
        getFormula()
    }, [])

    const {
        getBillPaymentGradeClassStudentPdf,
        isLoading,
        // getCrossHoliday,
        // crossHolidayData,
        serialCrossHolidayData,
        getSerialDateCrossHoliday

    } = useBillPaymentGradeClassStudent(
        {
            onFinish: () => { },
            onBefore: () => { }
        }
    )


    useEffect(() => {
        if (serialCrossHolidayData.length > 0) {
            let serialCrossHolidayDataFirst = (serialCrossHolidayData || []).find((element) => {
                return true
            })
            let bill_payment_holiday_datas = serialCrossHolidayDataFirst?.bill_payment_holiday_data || []
            let count = 0
            bill_payment_holiday_datas.forEach((ele) => {
                if (ele?.is_holiday === 0) {
                    count++
                }
            })
            let default_class_count = form.getFieldValue("default_class_count")
            if (default_class_count !== count) {
                message.info("上課日期與預設上課天數不同")
            }
        }
    }, [serialCrossHolidayData])
    return (
        <Row gutter={[0, 24]}>
            <Col span={24}>
                <Row justify={"end"} gutter={[4, 4]} style={{ 'marginTop': "1.5rem" }} >
                    <Col>
                        <ConfirmPopover
                            content={<>確認寄送通知</>}
                            title="通知繳費"
                            buttonContent="一鍵通知"
                            onOk={() => onNotification()}
                            size='large'
                        />
                    </Col>
                    <Col>
                        <Button
                            loading={isLoading}
                            size='large'
                            type='primary'
                            onClick={() => {
                                if (canExport) {

                                    getBillPaymentGradeClassStudentPdf({
                                        bill_payment_grade_class_id: form.getFieldValue('bill_payment_grade_class_id'),
                                        year: form.getFieldValue('year'),
                                        year_serial: form.getFieldValue('year_serial'),
                                        selectDate: selectDate
                                    })
                                }
                                else {
                                    message.info("需先進行儲存後，才能匯出繳費單")
                                }
                            }}
                        >
                            一鍵匯出
                        </Button>
                    </Col>
                    <Col>
                        {
                            <Popconfirm
                                open={popConfirmOpen}
                                title="確定修改繳費單？"
                                description={confirmMessage}
                                onOpenChange={handleOpenChange}
                                onConfirm={() => {
                                    form.submit()
                                }}
                                onCancel={() => { }}
                                okText="確認"
                                cancelText="取消"
                            >
                                <Button
                                    loading={loading}
                                    size='large'
                                    type='primary'
                                >
                                    儲存
                                </Button>
                            </Popconfirm>
                        }

                    </Col>
                    <Col>
                        <Button
                            loading={loading}
                            size='large'
                            type='default'
                            onClick={() => {
                                navigate(`/cramSchool/admin/AdminLessonTuitionOverview`)
                            }}
                        >
                            取消
                        </Button>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Spin spinning={loading}>
                    <AddTuitionForm
                        selectDate={selectDate}
                        setSelectDate={setSelectDate}
                        canExport={canExport}
                        setCanExport={setCanExport}
                        hasBackgroundColor={true}
                        edit={true}
                        propsForm={form}
                        formCount={formCount}
                        defaultValue={data}
                        open={open}
                        setOpen={setOpen}
                        onFormFinish={(values) => {
                            onFinish(values)
                        }}
                    />
                </Spin>
            </Col>
        </Row>
    )
}
export default AdminStudentTuition;